import { createMainResourceREST } from '../resource';
import {
  CRSettingBody,
  CRSettingBodyAPI,
  CRSettingKey,
  CRSettingSummary,
  CRSettingSummaryAPI,
  SettingsActions,
  SettingsState,
} from './types';

type AnySetting = CRSettingKey | CRSettingSummary | CRSettingBody | undefined;

function sameKeySetting(a: AnySetting, b: AnySetting): boolean {
  return a?.settingId === b?.settingId;
}

function getEndpointSetting(key: AnySetting): string {
  return key ? `/settings/${key.settingId}/` : '/settings/';
}

function parseSettingSummary(
  settingSummary: CRSettingSummaryAPI,
): CRSettingSummary {
  return settingSummary;
}

function parseSettingBody(settingDetail: CRSettingBodyAPI): CRSettingBody {
  return settingDetail;
}

const settingsStateSelector = (state: any): SettingsState => state.settings;

const settingsKeySelector = ({
  settingId,
}: CRSettingBody | CRSettingSummary): CRSettingKey => ({ settingId });

function mergeSettingBody(lastBody: CRSettingBody, currentBody: CRSettingBody) {
  return currentBody;
}

function combineSummaryBodySetting(
  summary?: CRSettingSummary,
  body?: CRSettingBody,
): CRSettingSummary {
  return {
    ...summary!,
    siteValue: (body?.siteDisplayValue ?? summary?.siteValue)!,
    userValue: (body?.userDisplayValue ?? summary?.userValue)!,
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'settings',
  getEndpointSetting,
  settingsStateSelector,
  sameKeySetting,
  parseSettingBody,
  parseSettingSummary,
  mergeSettingBody,
  combineSummaryBodySetting,
);

const settingsActions: SettingsActions = actions;

export * from './types';

export {
  settingsActions,
  reducer as settingsReducer,
  watches as settingsWatches,
  settingsStateSelector,
  settingsKeySelector,
};
